"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = void 0;
require("core-js/modules/es.promise.js");
var _CogManager = require("../../utils/CogManager");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Player extends Phaser.Physics.Arcade.Sprite {
  constructor(scene) {
    const x = 0;
    const y = 0;
    super(scene, x, y, "marty-in-plane");
    _defineProperty(this, "canMoveDown", true);
    _defineProperty(this, "canMoveUp", true);
    this.scene = scene;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.init();
    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
  }
  init() {
    if (!this.scene.input.keyboard) return;
    // const gravity = 2000 * (this.scene.sky?.scaleFactors.height || 1);
    // this
    //   .setOrigin(0.5, 1)  // Origin at the bottom center of the player
    //   // .setGravityY(gravity)
    //   .setCollideWorldBounds(false)
    //   .setBodySize(90, 120)
    //   .setOffset(35, 0)
    //   .setDepth(4);

    this.registerSounds();

    // Handle resizing
    this.scene.scale.once('resize', this.scaleToFit, this);
    this.scene.scale.once('resize', this.positionOnSky, this);
    this.scaleToFit();
    this.positionOnSky();
  }
  positionOnSky() {
    var _this$scene$sky, _this$scene$ground, _this$scene$sky2;
    this.setOrigin(0.5, 1) // Origin at the bottom center of the player
    // .setGravityY(gravity)
    .setCollideWorldBounds(false).setBodySize(90, 120).setOffset(35, 0).setDepth(4);

    // Position player at the bottom of the scaled background
    const heightScaled = ((_this$scene$sky = this.scene.sky) === null || _this$scene$sky === void 0 ? void 0 : _this$scene$sky.scaleFactors.height) || 1;
    const y = (((_this$scene$ground = this.scene.ground) === null || _this$scene$ground === void 0 ? void 0 : _this$scene$ground.y) || 1) - 250 * heightScaled;
    this.setY(y);
    this.setX(500 * (((_this$scene$sky2 = this.scene.sky) === null || _this$scene$sky2 === void 0 ? void 0 : _this$scene$sky2.scaleFactors.width) || 1));
  }
  scaleToFit() {
    var _this$scene$sky3;
    // Use the scale factor from the Sky class to maintain consistency
    const scaleFactor = ((_this$scene$sky3 = this.scene.sky) === null || _this$scene$sky3 === void 0 ? void 0 : _this$scene$sky3.scaleFactors.height) || 1;
    const width = 285;
    const height = 285;

    // Apply the scale factor to the player
    this.setDisplaySize(width * scaleFactor, height * scaleFactor);
  }
  getStartTrigger() {
    /* If the player is connected to a cog, use the cog's buttonClick state to determine if the player should jump / start the game */
    /* Otherwise, use the W or S keys to determine if the player should jump / start the game */
    const connectedCog = (0, _CogManager.getConnectedCog)();
    if (connectedCog) {
      const buttonClick = connectedCog.publishedDataAnalyser.cogState.buttonClick;
      if (buttonClick === "click" || buttonClick === "release") {
        return buttonClick;
      } else if (buttonClick === "none") {
        return "release";
      }
    } else {
      if (!this.scene.cursors) return null;
      const {
        up
      } = this.scene.cursors;
      if (up.isDown) {
        return "click";
      } else {
        return "release";
      }
    }
    return null;
  }
  actionDecider(button) {
    if (!button) return;
    if (button === "click") {
      var _this$scene$selectedC, _this$scene$selectedC2;
      if (((_this$scene$selectedC = this.scene.selectedCogClickedBlock) === null || _this$scene$selectedC === void 0 ? void 0 : _this$scene$selectedC.block) === "moveup") {
        this.moveUp();
      } else if (((_this$scene$selectedC2 = this.scene.selectedCogClickedBlock) === null || _this$scene$selectedC2 === void 0 ? void 0 : _this$scene$selectedC2.block) === "movedown") {
        this.moveDown();
      }
    } else if (button === "release") {
      var _this$scene$selectedC3, _this$scene$selectedC4;
      if (((_this$scene$selectedC3 = this.scene.selectedCogNoClickBlock) === null || _this$scene$selectedC3 === void 0 ? void 0 : _this$scene$selectedC3.block) === "movedown") {
        this.moveDown();
      } else if (((_this$scene$selectedC4 = this.scene.selectedCogNoClickBlock) === null || _this$scene$selectedC4 === void 0 ? void 0 : _this$scene$selectedC4.block) === "moveup") {
        this.moveUp();
      }
    }
  }
  async moveUp() {
    if (!this.canMoveUp) return;
    const move = 10;
    for (let i = 0; i < move; i++) {
      this.setY(this.y - .3);
      await new Promise(resolve => setTimeout(resolve, 10));
    }
  }
  async moveDown() {
    if (!this.canMoveDown) return;
    const move = 10;
    for (let i = 0; i < move; i++) {
      this.setY(this.y + .5);
      await new Promise(resolve => setTimeout(resolve, 10));
    }
  }
  isOffScreen() {
    const bounds = this.getBounds();
    const adjustedGameWidth = this.scene.scale.width;
    const isOffScreen = bounds.right < 0 || bounds.left > adjustedGameWidth;
    return isOffScreen;
  }
  update() {
    const isCogsButtonClickedOrSpaceDown = this.getStartTrigger();
    this.actionDecider(isCogsButtonClickedOrSpaceDown);

    // if (isCogsButtonClickedOrSpaceDown && !this.scene.isGameRunning && !this.scene.isGameOverVisible) {
    //   this.scene.handleGameStart();
    // }

    // if (!this.scene.isGameRunning) {
    //   return;
    // }
  }
  registerSounds() {
    this.hitSound = this.scene.sound.add("hit", {
      volume: 0.4
    });
  }
  die() {
    var _this$hitSound;
    this.anims.pause();
    this.setTexture("marty-hurt");
    (_this$hitSound = this.hitSound) === null || _this$hitSound === void 0 || _this$hitSound.play();
  }
}
exports.Player = Player;